
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.669 0C18.07 0 19.99 2.025 20 5.596v9.807C20 18.973 18.07 21 14.669 21H5.33C1.929 21 0 18.974 0 15.403V5.598C0 2.025 1.929 0 5.33 0h9.339zM10.5 4.337a.806.806 0 00-.89 0 .9.9 0 00-.391.829v10.7c.051.451.41.787.83.787.431 0 .79-.336.83-.787v-10.7a.872.872 0 00-.379-.83zM5.83 7.78a.79.79 0 00-.88 0 .898.898 0 00-.39.829v7.256a.842.842 0 00.829.787c.431 0 .79-.336.83-.787V8.61a.9.9 0 00-.389-.83zm9.259 3.811a.805.805 0 00-.889 0 .861.861 0 00-.38.83v3.444c.04.451.399.787.83.787.42 0 .779-.336.83-.787v-3.444a.89.89 0 00-.391-.83z","fill":"#fff"}})])
          )
        }
      }
    